export default __webpack_public_path__ + "static/media/Welcome.2290ece8.png";